import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`

export const SelectedItemLabel = styled.div`
  color: var(--Foreground-Neutral, #14171f);

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */

  @media (max-width: ${({ theme }) => theme.responsive.mobile.valueString}) {
    flex: 1;
    color: var(--Foreground-Neutral, #14171f);

    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 150% */
  }
`

export const ItemContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
`
